import React, { useEffect, useState } from 'react';
import {
    Box,
    Card,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Chip,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useThemeContext } from '../../../Context/ThemeContext';
import { DARKCOLORS, LIGHTCOLORS } from '../../../Utils/constants';
import { getBowlsData } from '../../../Services/authService';
import './MembershipCards.css';
import { BowlIcon, Bowlcashback, Bowlpending, NafPoint } from '../../../Components/Layouts/CustomIcons';

const BowlSummary = ({ membershipId }) => {
    const { t } = useTranslation();
    const { mode } = useThemeContext();

    const inputBoxColor = mode === 'dark' ? DARKCOLORS.GreyScale10 : LIGHTCOLORS.GreyScale10;
    const textColor = mode === 'dark' ? DARKCOLORS.HeadingLightBackground : LIGHTCOLORS.HeadingLightBackground;
    const bodyColor = mode === 'dark' ? DARKCOLORS.BodyLightBackground : LIGHTCOLORS.BodyLightBackground;
    const dangerColor = mode === 'dark' ? DARKCOLORS.Danger100 : LIGHTCOLORS.Danger100;
    const dangerColor1 = mode === 'dark' ? DARKCOLORS.Danger500 : LIGHTCOLORS.Danger500;
    const borderColor = mode === 'dark' ? DARKCOLORS.GreyScale30 : LIGHTCOLORS.GreyScale30;
    const iconBGColor = mode === 'dark' ? DARKCOLORS.BodyDarkBackground : LIGHTCOLORS.BodyDarkBackground;

    const [bowlsData, setBowlsData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!membershipId) return;

        const fetchBowlsData = async () => {
            try {
                setLoading(true);
                setError(null);
                const data = await getBowlsData(membershipId);
                setBowlsData(data);
            } catch (err) {
                console.error('Failed to fetch bowls data:', err);
                setError(err.message || 'Failed to load bowls data');
            } finally {
                setLoading(false);
            }
        };

        fetchBowlsData();
    }, [membershipId]);

    if (!membershipId) return null;

    if (loading) {
        return (
            <Box sx={{ my: 2 }}>
                <Typography sx={{ color: bodyColor, fontFamily: 'Satoshi', fontSize: '13px' }}>
                    {t('vendingMachines.Loading')}
                </Typography>
            </Box>
        );
    }

    if (!bowlsData) {
        return (
            <Box sx={{ my: 2 }}>
                <Typography sx={{ color: bodyColor, fontFamily: 'Satoshi', fontSize: '13px' }}>
                    {t('membershipCards.noBowlsData', 'No bowl return data available')}
                </Typography>
            </Box>
        );
    }

    const { pendingReturns = 0, totalReturned = 0, cashbackEarned = 0, 
        cashbackPoints = 0, bowls = [] } = bowlsData;

    return (
        <Box>
            <Typography variant="subtitle1" className='add-machine margin-zero'>
                {t('membershipCards.totalBowls', 'Bowls')}
            </Typography>

            {/* Stats Cards */}
            <Box className='bowl-stats-cards-container'
            >
                <Box
                    sx={{
                        p: "11px 5px",
                        display: "flex",
                        alignItems: "center",
                        gap: '6px',
                        bgcolor: inputBoxColor,
                        boxShadow: "none",
                        borderRadius: "12px",
                    }}
                >
                    <Box sx={{
                        width: "42px",
                        height: "42px",
                        aspectRatio: "1 / 1",
                        bgcolor: iconBGColor,
                        borderRadius: "50%",
                        // border: `1px solid ${borderColor}`,
                        boxShadow: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }} >

                        <Bowlpending />
                    </Box>
                    <Box>
                        <Typography className='bowl-card-title' variant="caption" sx={{ color: bodyColor, }}>
                            {t('membershipCards.pendingReturns')}
                        </Typography>
                        <Typography className='bowl-card-count' variant="h5" sx={{ color: textColor, margin: 0 }}>
                            {String(pendingReturns).padStart(2, '0')}
                        </Typography>
                    </Box>
                </Box>

                <Box
                    sx={{
                        p: "11px 9px",

                        display: "flex",
                        alignItems: "center",
                        gap: '6px',
                        bgcolor: inputBoxColor,
                        boxShadow: "none",
                        borderRadius: "12px",
                    }}
                >
                    <Box sx={{
                        width: "48px",
                        height: "48px",
                        aspectRatio: "1 / 1",
                        bgcolor: iconBGColor,
                        borderRadius: "50%",
                        // border: `1px solid ${borderColor}`,
                        boxShadow: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}> <BowlIcon />
                    </Box>
                    <Box>
                        <Typography className='bowl-card-title' variant="caption" sx={{ color: bodyColor, }}>
                            {t('membershipCards.bowlsReturned')}
                        </Typography>
                        <Typography className='bowl-card-count' variant="h5" sx={{ color: textColor, }}>
                            {String(totalReturned).padStart(2, '0')}
                        </Typography>

                    </Box>
                </Box>

                <Box
                    sx={{
                        p: "6px",
                        display: "flex",
                        alignItems: "center",
                        gap: '6px',

                        bgcolor: inputBoxColor,
                        boxShadow: "none",
                        borderRadius: "12px",
                    }}
                >
                    <Box sx={{
                        width: "48px",
                        height: "48px",
                        aspectRatio: "1 / 1",
                        bgcolor: iconBGColor,
                        borderRadius: "50%",
                        // border: `1px solid ${borderColor}`,
                        boxShadow: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}>  <Bowlcashback />
                    </Box>
                    <Box>
                        <Typography className='bowl-card-title' variant="caption" sx={{ color: bodyColor, }}>
                            {t('membershipCards.cashback', 'Cashback')} {t('membershipCards.balance', 'Earned')}
                        </Typography>
                        <Typography className='bowl-card-count' variant="h5" sx={{ color: textColor, }}>
                           € {cashbackEarned}
                        </Typography>
                    </Box>
                </Box>
                <Box
                    sx={{
                        p: "11px 9px",
                        display: "flex",
                        alignItems: "center",
                        gap: '6px',
                        bgcolor: inputBoxColor,
                        boxShadow: "none",
                        borderRadius: "12px",
                    }}
                >
                    <Box sx={{
                        width: "48px",
                        height: "48px",
                        aspectRatio: "1 / 1",
                        bgcolor: iconBGColor,
                        borderRadius: "50%",
                        // border: `1px solid ${borderColor}`,
                        boxShadow: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}>  <NafPoint />
                    </Box>
                    <Box>
                        <Typography className='bowl-card-title' variant="caption" sx={{ color: bodyColor, }}>
                            {t("membershipCards.sustainability_points")}
                        </Typography>
                        <Typography className='bowl-card-count' variant="h5" sx={{ color: textColor, fontSize: '22px !important' }}>
                            {
                                cashbackPoints}
                        </Typography>
                    </Box>
                </Box>
            </Box>

            {/* Bowls Table */}
            <TableContainer
                component={Card}
                elevation={0}
                sx={{
                    boxShadow: "none",
                    bgcolor: inputBoxColor,
                    borderRadius: "6px",
                    p: 2,
                    paddingBottom: "10px",

                }}
            >
                <Table
                    sx={{
                        borderCollapse: "collapse",
                        tableLayout: 'fixed',
                        "& td, & th": {
                            borderLeft: "none",
                            borderRight: "none",
                            borderBottom: "none",
                        },
                        minWidth: {
                            xs: 400,
                            md: "100%",
                        },
                    }}
                >
                    <TableHead>
                        <TableRow>
                            <TableCell width="33%" className='bowl-sumHead-cell bowl-text' sx={{ color: textColor, fontFamily: 'Satoshi-medium', fontWeight: 500, fontSize: '14px', borderBottom: `1px solid ${borderColor}` }}>
                                {t('vendingMachines.bowl', 'Bowl')}
                            </TableCell>
                            <TableCell width="33%" className='bowl-sumHead-cell bowl-text' sx={{ color: textColor, fontFamily: 'Satoshi-medium', textAlign: 'center', fontWeight: 500, fontSize: '14px', borderBottom: `1px solid ${borderColor}` }}>
                                {t('vendingMachines.quantity', 'Quantity')}
                            </TableCell>
                            <TableCell width="33%" className='bowl-sumHead-cell bowl-text' align="right" sx={{ color: textColor, fontFamily: 'Satoshi-medium', fontWeight: 500, fontSize: '14px', borderBottom: `1px solid ${borderColor}` }}>
                                {t('membershipCards.expiringIn', 'Expiring In')}
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {bowls.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={3} align="center" className='bowl-summary-cell' sx={{ color: bodyColor, py: 3, borderTop: `1px solid ${borderColor}` }}>
                                    {t('membershipCards.noBowlsData')}
                                </TableCell>
                            </TableRow>
                        ) : (
                            bowls.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell width="33%" className='bowl-summary-cell' sx={{ color: bodyColor, borderTop: `1px solid ${borderColor}` }}>
                                        {row.bowlName}
                                    </TableCell>
                                    <TableCell width="33%" className='bowl-summary-cell' sx={{ color: bodyColor, textAlign: 'center', borderTop: `1px solid ${borderColor}` }}>
                                        {row.quantity}
                                    </TableCell>
                                    <TableCell width="33%" align="right" sx={{ color: dangerColor, borderTop: `1px solid ${borderColor}` }}>
                                        <Chip
                                            label={`${row.daysLeft} ${t('vendingMachines.daysLeft', 'days left')}`}
                                            size="small"
                                            className='bowl-summary-cell'
                                            sx={{
                                                bgcolor: dangerColor,
                                                color: dangerColor1,
                                                fontSize: "13px",
                                                fontWeight: 500,
                                                height: 20,
                                                border: 'none !important',
                                                borderRadius: "16px",
                                                "& .MuiChip-label": {
                                                    px: 1,
                                                },
                                                ml: "auto",
                                            }}
                                        />
                                    </TableCell>
                                </TableRow>
                            )))
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default BowlSummary;
